import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setIsError(false);

        try {
            const response = await fetch('https://healthcard.searchisend.com/health_api/forgot_password.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'Failed to process request.');
            }

            setMessage(result.message);
            setIsError(false);
        } catch (error) {
            setMessage(error.message);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="glass p-8 md:p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] w-full max-w-md relative">
            <h2 className="text-4xl font-extrabold text-brand-secondary text-center mb-4 tracking-tight">Forgot Password</h2>
            <p className="text-center text-slate-500 font-medium mb-8">
                Enter your registered email address and we will send you a secure link to reset your password.
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label className="block text-sm font-semibold text-brand-secondary mb-1.5 ml-1">Email Address</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        className="w-full p-4 bg-white/60 text-brand-secondary rounded-2xl border border-white/40 focus:outline-none focus:ring-2 focus:ring-brand-primary placeholder-slate-400 font-medium transition-shadow focus:bg-white"
                    />
                </div>

                <button
                    type="submit"
                    disabled={isLoading || !email}
                    className="w-full p-4 mt-2 bg-brand-primary hover:bg-emerald-700 rounded-full font-bold text-white transition-all transform hover:-translate-y-1 shadow-lg shadow-emerald-700/30 disabled:bg-slate-300 disabled:transform-none disabled:shadow-none text-lg"
                >
                    {isLoading ? 'Sending Link...' : 'Send Reset Link'}
                </button>

                {message && (
                    <div className={`mt-6 text-center p-4 rounded-xl font-medium border ${isError ? 'bg-red-50 text-red-700 border-red-200' : 'bg-green-50 text-emerald-700 border-emerald-200'}`}>
                        {message}
                    </div>
                )}

                <div className="mt-6 text-center text-brand-secondary font-medium">
                    Remember your password? <span onClick={() => navigate('/login')} className="text-brand-primary cursor-pointer hover:underline font-bold">Login here</span>
                </div>
            </form>
        </div>
    );
}

export default ForgotPassword;
